import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const engravingFragment = `
    on ${QueryType.skus} {
        is_engravable
    }
`;

export const engravingFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: engravingFragment
    };
};
